import type { ConnectionTarget } from "@t3tools/client-runtime/connection";

import { isDesktopLocalConnectionTarget } from "./desktopLocal";

/**
 * A preview webview and its automation host belong to the desktop runtime that
 * owns the backend. Remote/relay/SSH environments must stay on the shared
 * remote-browser surface even when the viewer itself is Electron.
 */
export function isCoLocatedPreviewTarget(target: ConnectionTarget | null | undefined): boolean {
  return (
    target?._tag === "PrimaryConnectionTarget" ||
    (target != null && isDesktopLocalConnectionTarget(target))
  );
}

export function canUseCoLocatedPreview(input: {
  readonly target: ConnectionTarget | null | undefined;
  readonly isElectron: boolean;
  readonly hasPreviewBridge: boolean;
}): boolean {
  return input.isElectron && input.hasPreviewBridge && isCoLocatedPreviewTarget(input.target);
}
